interface Props {
  color?: string;
}

const SocialBoatSVG: React.FC<Props> = ({ color }) => {
  return (
    <svg className="w-full h-full" viewBox="0 0 28 24" fill="none">
      <path
        d="M23.611 13.03h-4.205l3.066-3.17h5.23l-2.386 2.445a2.38 2.38 0 01-1.705.724zM4.092 9.86h4.206l-3.066 3.17H0l2.385-2.446a2.381 2.381 0 011.707-.725z"
        fill={color ? color : "#FF5970"}
      />
      <path
        d="M8.158 9.86h14.838l-3.258 3.168H4.953L8.158 9.86zM9.032 7.846H4.148l1.925-2.002a3.204 3.204 0 012.31-.992h3.552L9.032 7.846zM17.19 4.852h4.886l-1.925 2.002a3.204 3.204 0 01-2.308.992h-3.554l2.901-2.994z"
        fill={color ? color : "#FF5970"}
      />
      <path
        d="M11.932 4.852h5.236l-2.901 2.994H9.031l2.901-2.994zM12.243 2.9H8.625L10.55.963A3.253 3.253 0 0112.86 0h3.552l-2.006 2.006a3.052 3.052 0 01-2.163.895zM18.7 15.18h4.886l-1.925 2.002a3.203 3.203 0 01-2.305.993h-3.56L18.7 15.18zM10.542 18.175H5.656l1.925-2.003a3.202 3.202 0 012.309-.992h3.553l-2.9 2.995zM15.783 18.174h-5.236l2.9-2.994h5.236l-2.9 2.994zM15.487 20.125h3.62l-1.925 1.94a3.253 3.253 0 01-2.308.961H11.32l2.006-2.007a3.06 3.06 0 012.161-.894z"
        fill={color ? color : "#FF5970"}
      />
    </svg>
  );
};

export default SocialBoatSVG;
